// Mock data for luxury travel agency

export const destinations = [
  {
    id: 1,
    name: "Santorini",
    country: "Greece", 
    image: "https://images.unsplash.com/photo-1539889128541-6293f3fa0e0a",
    description: "Exclusive cliffside villas with infinity pools overlooking the Aegean Sea"
  },
  {
    id: 2,
    name: "Maldives", 
    country: "Indian Ocean",
    image: "https://images.unsplash.com/photo-1637576308588-6647bf80944d",
    description: "Overwater bungalows in pristine turquoise lagoons"
  },
  {
    id: 3,
    name: "Swiss Alps",
    country: "Switzerland", 
    image: "https://images.unsplash.com/photo-1698475330880-64d55b0533e4",
    description: "Luxury mountain resorts with Alpine panoramas"
  },
  {
    id: 4,
    name: "Dubai",
    country: "UAE",
    image: "https://images.unsplash.com/photo-1738260530641-f945fa20a6cf",
    description: "Ultra-modern luxury hotels and exclusive experiences"
  },
  {
    id: 5,
    name: "Bora Bora",
    country: "French Polynesia", 
    image: "https://images.pexels.com/photos/3601426/pexels-photo-3601426.jpeg",
    description: "Private island resorts in the heart of the Pacific"
  },
  {
    id: 6,
    name: "Aspen",
    country: "USA",
    image: "https://images.unsplash.com/photo-1698135068989-5e5008a8a3b2",
    description: "Elite ski lodges and winter luxury experiences"
  },
  {
    id: 7,
    name: "Mykonos",
    country: "Greece",
    image: "https://images.pexels.com/photos/33967073/pexels-photo-33967073.jpeg", 
    description: "Sophisticated beach clubs and luxury villa estates"
  },
  {
    id: 8,
    name: "Burj Al Arab",
    country: "Dubai", 
    image: "https://images.pexels.com/photos/2041556/pexels-photo-2041556.jpeg",
    description: "The world's most luxurious hotel experience"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Golden Voyage curated the most extraordinary Mediterranean journey. Every detail exceeded our expectations.",
    author: "Elizabeth Hamilton",
    title: "Private Banking Executive"
  },
  {
    id: 2,
    quote: "Their concierge service transformed our African safari into an unforgettable adventure of a lifetime.", 
    author: "Marcus Chen",
    title: "Tech Entrepreneur"
  },
  {
    id: 3,
    quote: "The exclusive access to private islands and luxury yachts made our honeymoon truly magical.",
    author: "Isabella Rodriguez", 
    title: "Art Gallery Owner"
  }
];

export const experiences = [
  {
    title: "Private Villa Collection",
    description: "Handpicked luxury estates in the world's most coveted destinations"
  },
  {
    title: "Yacht & Cruise Charters", 
    description: "Exclusive access to premium vessels and luxury cruise experiences"
  },
  {
    title: "24/7 Concierge Service",
    description: "Dedicated luxury travel specialists ensuring seamless experiences"
  }
];

export const membershipBenefits = [
  "VIP airport lounge access worldwide",
  "Complimentary room upgrades at luxury hotels", 
  "Exclusive access to private events and experiences",
  "Priority booking for limited luxury experiences",
  "Personal travel consultant dedicated to your preferences"
];